<script>
  import Page from '@components/page'

  let { 
    pageTitle,
    title, subtitle,
    links,
    Icon,
    adminLink,
    adminActions,
    adminArea,
    navigationProps = {},
    titleProps = {},
    tags,
    main,
    aside,
    children,
    buttons,
  } = $props()
</script>

<Page.Layout {title}>

  <Page.Navigation title={pageTitle || title} {Icon} {links} {adminLink} {adminArea} {adminActions} {...navigationProps} />

  <Page.Titles title={title} {subtitle} {buttons} {...titleProps} />

  {#if tags}
    <div class="flex items-center gap-2 px-4 sm:px-8 pt-4">
      {@render tags()}
    </div>
  {/if}

  <Page.Content {main} {aside} {children} />
</Page.Layout>